import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Check, X, Star } from 'lucide-react';
import Faq from "./GoProFaq.jsx";

function GoPro({ open, onClose, openConfirmationModal }) {
    const features = [
        {
            title: "Free to Sign Up and Use",
            description: "Signing up and using NuLifeSpan Rx will always be free",
            cashback: true,
            pro: true
        },
        {
            title: "Cashback on Every Transaction",
            description: "Earn cash back anytime you use your card",
            cashback: true,
            pro: true
        },
        {
            title: "Unique Member Card to Share",
            description: "Share your card with friends and family and earn cashback when they use it",
            cashback: true,
            pro: true
        },
        {
            title: "Add to Apple or Google Wallet",
            description: "Download your unique member card to you Apple or Google wallet",
            cashback: true,
            pro: true
        },
        {
            title: "Basic Member Dashboard",
            description: "Track all your rewards and payouts",
            cashback: true,
            pro: true
        },
        {
            title: "Unique Referrals Link to Build a Business",
            description: "Share your referral link to always get paid on referrals, even if they get their own member card",
            cashback: false,
            pro: true
        },
        {
            title: "Earn More With Tiered Rewards",
            description: "The more you refer the higher rewards rate you will earn",
            cashback: false,
            pro: true
        },
        {
            title: "Rewards on Referrals of Your Referrals",
            description: "Earn cashback on all transactions of your referrals as well as others they refer",
            cashback: false,
            pro: true
        },
        {
            title: "Pricing Tool",
            description: "Create and share coupons with your embedded referral link",
            cashback: false,
            pro: true
        },
        {
            title: "Pro Member Dashboard",
            description: "Access Pro Member tools such as detailed analytics and other tools to help you build your business",
            cashback: false,
            pro: true
        },
        {
            title: "Access to Extensive Training",
            description: "Get help with best practices for building and managing your business",
            cashback: false,
            pro: true
        },
        {
            title: "Print Physical Cards",
            description: "Ability to print physical cards for distribution",
            cashback: false,
            pro: true
        }
    ];

    const handleConfirmGoPro = () => {
        onClose();
        openConfirmationModal();
    };

    return (
        <Dialog open={open} onOpenChange={onClose}>
            <DialogContent className="max-w-4xl max-h-[90vh] overflow-y-auto">
                <DialogHeader>
                    <DialogTitle className="text-2xl">
                        Become a Pro Member
                    </DialogTitle>
                    <DialogDescription>
                        Nothing to lose and so much to gain!
                    </DialogDescription>
                </DialogHeader>

                <div className="space-y-6">
                    {/* Comparison Table */}
                    <div className="overflow-x-auto">
                        <table className="w-full border-collapse">
                            <thead>
                                <tr className="border-b-2">
                                    <th className="text-left p-4 font-semibold">Features</th>
                                    <th className="text-center p-4 font-semibold">Cashback Member</th>
                                    <th className="text-center p-4 font-semibold bg-muted">
                                        <div className="flex items-center justify-center gap-2">
                                            Pro Member
                                            <Star className="h-5 w-5 fill-accent text-accent" />
                                        </div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {features.map((feature, index) => (
                                    <tr key={index} className="border-b hover:bg-gray-50">
                                        <td className="p-4">
                                            <h4 className="font-semibold text-primary">{feature.title}</h4>
                                            <p className="text-sm text-muted-foreground">{feature.description}</p>
                                        </td>
                                        <td className="text-center p-4">
                                            {feature.cashback ? (
                                                <Check className="h-6 w-6 text-green-600 mx-auto" />
                                            ) : (
                                                <X className="h-6 w-6 text-muted-foreground/40 mx-auto" />
                                            )}
                                        </td>
                                        <td className="text-center p-4 bg-muted">
                                            {feature.pro ? (
                                                <Check className="h-6 w-6 text-green-600 mx-auto" />
                                            ) : (
                                                <X className="h-6 w-6 text-muted-foreground/40 mx-auto" />
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    {/* Go Pro Button */}
                    <div className="flex justify-center">
                        <Button
                            onClick={handleConfirmGoPro}
                            size="lg"
                            variant="secondary"
                            className="text-lg px-8 py-6"
                        >
                            Go Pro
                        </Button>
                    </div>

                    {/* FAQs Section */}
                    <div className="space-y-4">
                        <h5 className="text-xl font-semibold">FAQs</h5>
                        <Faq />
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
}

export default GoPro;

